import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import { useAppSelector } from "store";
import { motion } from "framer-motion";
import Logo from "components/logo";
import { useSite } from "hooks/use-site";
import { LoadingButton } from "@mui/lab";

const SuccessRegistration = () => {
  const { logo, frontWalletAuthPageColor } = useSite();
  const navigate = useNavigate();
  const newUser = useAppSelector((state) => state.register.newUser);

  if (!newUser) {
    navigate("/signin");
  }

  return (
    <Box
      display={"flex"}
      alignItems="center"
      justifyContent="cente"
      height={"100vh"}
    >
      <Container maxWidth="sm">
        <Card elevation={24} component={motion.div} layoutId="auth-card">
          <Box
            paddingY={2.5}
            paddingX={4}
            sx={{ bgcolor: `${frontWalletAuthPageColor}` }}
          >
            <Logo src={logo} />
          </Box>
          <CardContent>
            <Stack spacing={4}>
              <Typography variant="subtitle1">
                Thank you for choosing our platform. We have sent a confirmation
                email to {newUser ? newUser.email : "a@b.com"}. Please check
                (and your Spam folder as well).
              </Typography>
              <Stack spacing={2}>
                <Box display="flex">
                  <LoadingButton
                    onClick={() => navigate("/signin")}
                    fullWidth
                    variant="contained"
                  >
                    Got it
                  </LoadingButton>
                </Box>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};
export default SuccessRegistration;
